module.exports = __webpack_public_path__ + "img/x-red.e57c09b4.svg";